module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0